import { render } from "./LanguageSelector.vue?vue&type=template&id=e75aa892&bindings={}"
import script from "./LanguageSelector.vue?vue&type=script&lang=js"
export * from "./LanguageSelector.vue?vue&type=script&lang=js"
script.render = render

export default script